@import '~@customink/design-tokens/build/scss/variables.scss';
@import '../../global-styles/index.scss';
@import '../../respond-to.scss';

customer-contact {
  height: 100%;

  // Styles for CustomerContact -- Simple Header
  .ghf-customerContact--simple {
    display: flex;
    align-items: center;
    gap: $spacing-8;
    height: 100%;

    div:first-of-type {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    a.img {
      @include icon('assets/support_red.svg');
    }

    .ghf-customerContact {
      line-height: 125%;
      &-text {
        display: none;
        font-size: 12px;
        color: $color-gray-slate-default;
      }
      &-storeText {
        display: none;
        font-size: $typography-button-medium-size;
        margin: 0;
        color: $color-red-default;
        text-decoration: none;
      }

      @include breakpoint('md') {
        &-helpText {
          display: none;
        }
        &-storeText {
          display: block;
        }
      }

      @include breakpoint('lg') {
        padding: 0 $spacing-16;
        display: flex;
        align-items: center;
        gap: $spacing-8;
        border-right: 1px solid $color-gray-accent;

        &-helpText {
          display: none;
        }

        &-text {
          display: block;
        }
        &-storeText {
          display: block;
        }
      }

      @include breakpoint('xl') {
        padding: 0 $spacing-16;
        display: flex;
        align-items: center;
        gap: $spacing-8;
        border-right: 1px solid $color-gray-accent;

        &-helpText {
          display: none;
        }

        &-text {
          display: block;
        }

        &-storeText {
          display: block;
          color: $color-red-default;
        }
      }
    }
  }

  .ghf-customerContact--default {
    display: flex;
    height: 100%;
    cursor: pointer;
    text-decoration: none;
    color: $color-shade-white;
    &:link, &:visited, &:hover {
      color: $color-shade-white;
    }
    align-items: center;
    gap: 4px;
    white-space: nowrap;

    .ghf-customerContact {
      &-link {
        &--desktop {
          display: none;
        }

        @include breakpoint('lg') {
          &--desktop {
            display: block;
          }
          &--mobile {
            display: none;
          }
        }

        @include breakpoint('xl') {
          &--desktop {
            display: block;
          }
          &--mobile {
            display: none;
          }
        }
      }
    }
  }
}
